export default {
    login:{
        account:'Account',
        password:'Password',
        login:'Login',
        reste:'Reset',
        inputAccount:"Please enter a username!",
        inputPassword:'Please enter your password!',
        lengthInvalid:'The password is between 8-16 characters long!',
        loginFaild:'Login failed'
    },
    startPage:{
        title:'Vue Study'
    },
    menu:{
        home:'Home',
        Management:'Management',
        Personnel:'Personnel',
        Menu1:'Menu',
        HelloWorld:'HelloWorld'
    },
    userMenu:{
        Setting:'Setting',
        Exit:'Exit'
    },
    options:{
        Title:'Setting',
        Language:'Language'
    },
    global:{
        Export:'Export'
    },
    license:{
        Label:{
            Export:'Export Organization',
            FilterCompanyName:'Company Name',
            FilterCompanyCode:'Company Code',
            FilterState:'State',
            FilterCity:'City',
            FilterValid:'Status',
            FilterAll:'All',
            FilterEnabled:'Enabled',
            FilterLocked:'Locked',
            FilterCreateTime:'Create Time',
            FilterFrom:'From',
            FilterTo:'To'
        },
        Message:{
            ExportSuccess:'Organization export succeeded',
            ExportFailed:'Organization export failed'
        }
    }
}